import { useState, useCallback, useEffect } from 'react';
import { isMobile } from '../user-agent/user-agent.tsx';
import { useWindowEventServiceListener } from './use-window-event-service-listener.ts';
import { EventType } from '../../services/window-event-service.ts';
import { useIsSsr } from './use-is-ssr.tsx';

/**
 * Hook that returns is mobile.
 */
export const useIsMobile = (options?: {
  /**
   * In SSR, we have no information about the window size.
   */
  ssrDefault?: boolean;
}) => {
  const { isSsr } = useIsSsr();
  const [mobileState, setMobileState] = useState(isSsr ? options?.ssrDefault : isMobile());
  const mobile = isSsr && options?.ssrDefault !== undefined ? options.ssrDefault : mobileState;

  useEffect(() => {
    setMobileState(isMobile());
  }, []);

  const onWindowResize = useCallback(() => {
    setMobileState(isMobile());
  }, []);

  useWindowEventServiceListener(EventType.Resize, { listener: onWindowResize });

  return { isMobile: mobile, isDesktop: !mobile, isSsr };
};
